import {
  Avatar,
  Box,
  ButtonBase,
  Container,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from "@mui/material";
import React, {
  Suspense,
  lazy,
  useState,
  useRef,
  useContext,
  useEffect,
  useMemo,
} from "react";
import season3BgWeb from "../@shared/assets/season-3-bg-web.png";
import season3BgMobile from "../@shared/assets/season-3-bg-mobile.png";
import s3LogoOverlay1 from "../@shared/assets/s3-logo-overlay-1.png";
import s3LogoOverlay2 from "../@shared/assets/s3-logo-overlay-2.png";
import s3LogoOverlay3 from "../@shared/assets/s3-logo-overlay-3.png";
import { useNavigate } from "react-router-dom";
import NeoButton from "../components/NeoButton";
import JoinRoomModal from "../components/JoinRoomModal";
import JoinPartyModal from "../components/JoinPartyModal";
import StartRoomModal from "../components/StartRoomModal";
import {
  useAuthStore,
  useEnsureUserData,
  useLiveUserData,
} from "../@shared/store/useAuthStore";
import { useCardStore } from "../@shared/store/useCardsStore";
import SpriteAnimator from "../components/gamePlay/SpriteAnimator";
import {
  getBadgeByLevel,
  formatNumber,
  getQuestProgress,
  getRandomInt,
} from "../@shared/utils/Utils";
import { getIssuableInfinityCards } from "../@shared/game/cardPackEngine";
import { MainContext } from "../App";
import VoidCityScene from "../components/mapScenes/voidCity/VoidCityScene";
import SettingsDrawer from "../components/SettingsDrawer";
import WebJoystick from "../components/WebJoystick";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import NeoMenuItem from "../components/NeoItem";
import {
  Add,
  AddRoadRounded,
  AddRounded,
  ArrowForwardIos,
  InsertEmoticon,
  MenuRounded,
  AutoStoriesRounded,
  BoltRounded,
  GroupsRounded,
  HelpOutlineRounded,
  PlayArrowRounded,
  PublicRounded,
  StyleRounded,
  Widgets,
} from "@mui/icons-material";
import { starterQuests } from "../@shared/game/starterQuests";
import Toast from "../components/Toast";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  serverTimestamp,
  setDoc,
  updateDoc,
  onSnapshot,
  query,
  runTransaction,
  where,
  writeBatch,
} from "firebase/firestore";
import { db, functions as firebaseFunctions } from "../@shared/firebase/config";
import { useDriverTutorial } from "../@shared/utils/useDriverTutorial";
import InfinityOrb from "../components/InfinityOrb";
import TutorialInfinityOrb from "../components/TutorialInfinityOrb";
import { motion, useSpring } from "framer-motion";
import { startScreenTransition } from "../@shared/utils/startScreenTransition";
import AvatarIdolAnimation from "../components/idolAvatarAnimations/AvatarIdolAnimation";
import { normalizeAvatarName } from "../@shared/utils/SpritesMap";
import { yellow } from "@mui/material/colors";
import ModalComponent from "../components/ModalComponent";
import EmoteManagerModal from "../components/EmoteManagerModal";
// import LeagueModal from "../components/LeagueModal";
// import AnnouncementModal from "../components/AnnouncementModal";
// import SpinWheel from "../components/gamePlay/SpinWheel";
// import CardRewardModal from "../components/CardRewardModal";
// import TokenRewardModal from "../components/TokenRewardModal";
// import XPRewardModal from "../components/XPRewardModal";
import { v4 as uuidv4 } from "uuid";
import LayeredBackground from "../components/LayeredBackground";
// import season3Logo from "../@shared/assets/season-3-logo.png";
// import DashboardLightningLayer from "../components/DashboardLightningLayer";
import AudioManager from "../@shared/utils/AudioManager";
import ServerGateModal from "../components/ServerGateModal";
import InfinityTokenPurchaseModal from "../components/InfinityTokenPurchaseModal";
import CheckoutModal from "../components/StoreScreen/CheckoutModal";
import axios from "axios";
import { computeTotals } from "../@shared/store/useCartStore";
import {
  normalizeTokenProductForCart,
  tokenProducts,
} from "../@shared/game/tokenProducts";
import storyMissions from "../components/StoryMode/missions.json";
import { buildInitialStoryProgress } from "../@shared/utils/storyProgression";
import { buildInitialStoryState } from "../@shared/utils/storyState";

import {
  updatePlayerPresence,
  setPlayerOffline,
  subscribeToFriendsOnlineCount,
} from "../@shared/utils/roomFunctions";
import {
  isEventVisibleInUpcomingBadge,
} from "../@shared/utils/eventUtils";
import { Badge } from "@mui/material";
import {
  SOCIAL_LINKS,
  getConfiguredSocialLinks,
} from "../components/SocialLinksDock";
import {
  HudCta,
  HudCurrency,
  HudDock,
  HudDockItem,
  HudIconButton,
  LoadoutSlot,
  ModeTile,
  PlayerPlate,
} from "../components/dashboard/DashboardHud";
import { colors, glassPanelSx, gradients } from "../@shared/ui/tokens";
import { levelXPTable } from "../@shared/utils/levelXPTable";

// import EditProfileModal from "./EditProfileModal";

const EventsModal = lazy(() => import("../components/EventsModal"));
const PackOpeningModal = lazy(() => import("../components/PackOpeningModal"));
const QuestsAndRewardsModal = lazy(
  () => import("../components/QuestsAndRewardsModal"),
);
const LeaderBoardModal = lazy(() => import("../components/LeaderBoardModal"));
const MyQuestsModal = lazy(() => import("../components/MyQuestsModal"));
const MyPurchasesModal = lazy(() => import("../components/PurchasesModal"));
const AvatarSelectorModal = lazy(
  () => import("../components/mainMenu/AvatarSelectorModal"),
);
const StickerSelectorModal = lazy(
  () => import("../components/mainMenu/StickerSelectorModal"),
);
const AnimationSelectorModal = lazy(
  () => import("../components/mainMenu/AnimationSelectorModal"),
);
const FriendsModal = lazy(() => import("../components/FriendsModal"));
const MailModal = lazy(() => import("../components/MailModal"));
const NFTeamsModal = lazy(() => import("../components/NFTeamsModal"));
const LeagueModal = lazy(() => import("../components/LeagueModal"));
const AnnouncementModal = lazy(() => import("../components/AnnouncementModal"));
const SpinWheel = lazy(() => import("../components/gamePlay/SpinWheel"));
const CardRewardModal = lazy(() => import("../components/CardRewardModal"));
const TokenRewardModal = lazy(() => import("../components/TokenRewardModal"));
const LevelCheckModal = lazy(() => import("../components/LevelCheckModal"));
const SeasonPassModal = lazy(() => import("../components/SeasonPassModal"));
const BattleWalletModal = lazy(() => import("../components/BattleWalletModal"));
const ReferralModal = lazy(() => import("../components/ReferralModal"));

const sanitizeForFirestore = (value) => {
  if (value === undefined) return undefined;
  if (value === null) return null;

  if (Array.isArray(value)) {
    return value.map(sanitizeForFirestore).filter((v) => v !== undefined);
  }

  if (typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      const sv = sanitizeForFirestore(v);
      if (sv !== undefined) out[k] = sv;
    }
    return out;
  }

  return value;
};

const getRequestErrorMessage = (err, fallback) => {
  const raw = err?.response?.data?.error || err?.message || fallback;
  return String(raw).replace(/^([a-z-]+):\s*/i, "").trim() || fallback;
};

const POST_TRANSITION_MODAL_DELAY_MS = 1600;
const DAILY_LOGIN_DROP_AMOUNT = 25;
const hasDailyCooldownElapsed = (timestampMs) => {
  const value = Number(timestampMs || 0);
  if (!value) return true;
  return Date.now() - value >= 24 * 60 * 60 * 1000;
};
const buildDailyLoginDropReward = (grantedAt = Date.now()) => ({
  type: "infinity tokens",
  amount: DAILY_LOGIN_DROP_AMOUNT,
  reward: { currency: "Infinity Tokens" },
  source: "daily-login-drop",
  grantedAt,
});
const DASHBOARD_LOGO_OVERLAY_LAYERS = [
  {
    src: s3LogoOverlay1,
    opacity: 1,
    animate: { x: [-12, 10, -12], y: [8, -6, 8], scale: [1, 1.02, 1] },
    transition: { duration: 18, repeat: Infinity, ease: "easeInOut" },
  },
  {
    src: s3LogoOverlay2,
    opacity: 1,
    animate: { x: [10, -14, 10], y: [-10, 8, -10], scale: [1.015, 0.995, 1.015] },
    transition: { duration: 22, repeat: Infinity, ease: "easeInOut" },
  },
  {
    src: s3LogoOverlay3,
    opacity: 1,
    animate: { x: [-8, 6, -8], y: [-4, 10, -4], scale: [0.99, 1.01, 0.99] },
    transition: { duration: 20, repeat: Infinity, ease: "easeInOut" },
  },
];

const Dashboard = ({ tutorialMode = false }) => {
  const {
    navigate,
    partyId,
    setPartyId,
    setIsHost,
    isHost,
    Theme,
    setInfo,
    setMessage,
    setError,
    deviceType,
    screenLoading,
    setScreenLoading,
    gameScreenLoading,
    setGameScreenLoading,
    //account settings modal
    accountSettingsVisible,
    setAccountSettingsVisible,
    activeSection,
    setActiveSection,
  } = useContext(MainContext);
  const theme = useTheme();
  const isViewportMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = deviceType === "mobile" || isViewportMobile;

  //userData ====================================
  const { userData } = useAuthStore();
  const loadUserCards = useAuthStore((state) => state.loadUserCards);
  const loadUserCharacterCards = useAuthStore(
    (state) => state.loadUserCharacterCards,
  );
  const fetchCards = useCardStore((state) => state.fetchCards);
  useEnsureUserData({ decks: true, questData: true });
  useLiveUserData({
    enabled: !!userData?.id,
    rewards: true,
    purchases: true,
  });
  const {
    progress: tutorialProgress,
    sequence: tutorialSequence,
    advanceStep: advanceTutorialStep,
  } = useDriverTutorial(userData?.id, tutorialMode);

  const isTutorialSequenceActive =
    tutorialMode &&
    tutorialProgress?.currentSequence === "dashboardTutorial";
  const currentTutorialStep =
    tutorialSequence?.steps?.[tutorialProgress?.currentStepIndex];
  const currentTutorialSelector =
    currentTutorialStep?.selector;
  const isDashboardDialogueStep =
    isTutorialSequenceActive &&
    !currentTutorialSelector &&
    Boolean(currentTutorialStep?.text);
  const mobileTopRowHeight = 126;
  const mobileHeaderItemStyle = isMobile
    ? { minWidth: "56px", height: "30px" }
    : {};
  const mobileHeaderTokenStyle = isMobile
    ? { minWidth: "74px", height: "30px", width: "74px", marginLeft: 0 }
    : { width: "100%", marginLeft: "0%" };
  const mobileHeaderLabelStyle = isMobile
    ? { fontSize: "0.62rem", letterSpacing: "0.02em" }
    : {};
  const dashboardRailInnerStyle = isMobile
    ? {}
    : {
        background: "linear-gradient(180deg, #5b57ff 0%, #3b37d0 100%)",
      };
  const dashboardRailTileSize = { xs: 42, md: "6.5dvh" };
  const dashboardRailLabelStyle = isMobile
    ? { fontSize: 11, lineHeight: 1, mt: 0.25 }
    : {};

  const runTutorialTap = (
    driverId,
    onTap,
    {
      runActionDuringTutorial = false,
      skipAdvanceOnMatch = false,
      onStepMatched,
    } = {}
  ) => {
    if (!isTutorialSequenceActive) {
      onTap?.();
      return;
    }

    const selector = `[data-driver='${driverId}']`;
    if (currentTutorialSelector === selector) {
      if (runActionDuringTutorial) {
        onTap?.();
      }
      if (!skipAdvanceOnMatch) {
        advanceTutorialStep();
      }
      onStepMatched?.();
      return;
    }

    setMessage("Tap the highlighted menu item to continue.");
    setInfo(true);
  };

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  const isDevServer =
    hostname === "infinft-royale.web.app" ||
    // hostname.includes("localhost") ||
    hostname.includes("127.0.0.1");

  const allowedRoles = ["play_tester", "manager", "admin"];

  const hasAllowedRole = (userData?.roles || []).some((r) =>
    allowedRoles.includes(r),
  );

  const shouldGate = isDevServer && !hasAllowedRole;

  const PROD_URL = "https://infinftroyale.com";

  const { infinityCards } = useCardStore();
  const rewards = userData?.rewards ?? [];
  const quests = userData?.quests ?? [];
  const questLog = userData?.questLog ?? [];

  const [modalOpen, setModalOpen] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);

  const [startRoomVisible, setStartRoomVisible] = useState(false);
  const [joinRoomVisible, setJoinRoomVisible] = useState(false);
  const [joinPartyVisible, setJoinPartyVisible] = useState(false);
  const [questsAndRewardsVisible, setQuestsAndRewardsVisible] = useState(false);
  const [packOpeningVisible, setPackOpeningVisible] = useState(false);
  const [leaderboardVisible, setLeaderboardVisible] = useState(false);
  const [myQuestsVisible, setMyQuestsVisible] = useState(false);
  const [myPurchasesVisible, setMyPurchasesVisible] = useState(false);
  const [townQuestsVisible, setTownQuestsVisible] = useState(false);
  const [avatarSelectorVisible, setAvatarSelectorVisible] = useState(false);
  const [emotesVisible, setEmotesVisible] = useState(false);
  const [friendsVisible, setFriendsVisible] = useState(false);
  const [mailVisible, setMailVisible] = useState(false);
  const [nfTeamsVisible, setNfTeamsVisible] = useState(false);
  const [leagueVisible, setLeagueVisible] = useState(false);
  const [levelModalVisible, setLevelModalVisible] = useState(false);
  const [battleWalletVisible, setBattleWalletVisible] = useState(false);
  const [referralOpen, setReferralOpen] = React.useState(false);


  // 🔔 Announcements
  const [announcementModalVisible, setAnnouncementModalVisible] =
    useState(false);
  const [unreadAnnouncements, setUnreadAnnouncements] = useState([]);
  const [eventsModalVisible, setEventsModalVisible] = useState(false);
  const [eventsModalIntent, setEventsModalIntent] = useState(null);

  const [stickerSelectorVisible, setStickerSelectorVisible] = useState(false);
  const [animationSelectorVisible, setAnimationSelectorVisible] =
    useState(false);
  const [townQuests, setTownQuests] = useState(starterQuests);
  const [dailyModalOpen, setDailyModalOpen] = useState(false);
  const [tokenModalVisible, setTokenModalVisible] = useState(false);
  const [tokenPurchaseModalOpen, setTokenPurchaseModalOpen] = useState(false);
  const [tokenPurchaseBuyingKey, setTokenPurchaseBuyingKey] = useState(null);
  const [
    tokenPurchaseBattleWalletBuyingKey,
    setTokenPurchaseBattleWalletBuyingKey,
  ] = useState(null);
  const [tokenPurchaseError, setTokenPurchaseError] = useState(null);
  const [tokenCheckoutClientSecret, setTokenCheckoutClientSecret] =
    useState(null);
  const [tokenCheckoutOpen, setTokenCheckoutOpen] = useState(false);
  const [tokenCheckoutCartId, setTokenCheckoutCartId] = useState(null);
  const [xpModalVisible, setXpModalVisible] = useState(false);
  const [cardReward, setCardReward] = useState(null); // for card modals
  const [cardModalVisible, setCardModalVisible] = useState(false);
  const [claimingReward, setClaimingReward] = useState(null);
  const [rewardId, setRewardId] = useState(null);
  const [tokenModalReward, setTokenModalReward] = useState(null);
  const [tokenModalMode, setTokenModalMode] = useState("claim");
  const [dailyLoginDropGrantAt, setDailyLoginDropGrantAt] = useState(0);
  const [dailyLoginDropNoticeAt, setDailyLoginDropNoticeAt] = useState(0);
  const [seasonPassVisible, setSeasonPassVisible] = useState(false);

  const [isCheckingMatch, setIsCheckingMatch] = useState(true);
  const [resumingMatch, setResumingMatch] = useState(false);
  const spriteRef = useRef(null);
  const dailyLoginDropGrantingRef = useRef(false);

  const [canInteract, setCanInteract] = useState(false);

  const [friendsOnlineCount, setFriendsOnlineCount] = useState(0);
  const [upcomingEventsCount, setUpcomingEventsCount] = useState(0);
  const [unreadMailCount, setUnreadMailCount] = useState(0);
  const [pendingFriendsCount, setPendingFriendsCount] = useState(0);
  const [leagueTeamData, setLeagueTeamData] = useState(null);
  const [leagueMemberClaims, setLeagueMemberClaims] = useState([]);
  const [leagueMembersCount, setLeagueMembersCount] = useState(0);

  const ySpring = useSpring(0, {
    stiffness: 60,
    damping: 15,
  });

  useEffect(() => {
    const cb = (e) => setCanInteract(e.detail);
    window.addEventListener("interact-proximity", cb);
    return () => window.removeEventListener("interact-proximity", cb);
  }, []);

  useEffect(() => {
    const loop = () => {
      ySpring.set(-5);
      setTimeout(() => ySpring.set(5), 500);
      setTimeout(() => ySpring.set(-5), 1000);
    };
    const interval = setInterval(loop, 1000);
    return () => clearInterval(interval);
  }, []);

  const unclaimedRewardsAndQuests = rewards?.filter(
    (r) => r.claimed === false,
  ).length;
  const isAmbassador = !!userData?.roles?.includes("ambassador");
  const isStaff =
    !!userData?.roles?.includes("admin") || !!userData?.roles?.includes("manager");
  const isManagerOnly =
    !!userData?.roles?.includes("manager") && !userData?.roles?.includes("admin");
  const referralsLocked =
    !isAmbassador &&
    Number(userData?.level || 0) < 25 &&
    !String(userData?.level || "").toLowerCase().includes("m");
  const unclaimedPurchasesCount =
    userData?.purchases?.filter((item) => !item.claimed).length || 0;
  const communityLinks = useMemo(() => getConfiguredSocialLinks(SOCIAL_LINKS), []);
  const [communityAnchorEl, setCommunityAnchorEl] = useState(null);
  const xpPercent = useMemo(() => {
    const currentLevel = parseInt(userData?.level || "1", 10);
    const current = levelXPTable.find((lvl) => parseInt(lvl.level, 10) === currentLevel);
    const next = levelXPTable.find((lvl) => parseInt(lvl.level, 10) === currentLevel + 1);
    if (!current || !next) return null;
    const span = next.cumulativeXP - current.cumulativeXP || 1;
    return Math.round(((Number(userData?.xp || 0) - current.cumulativeXP) / span) * 100);
  }, [userData?.level, userData?.xp]);
  const isAdminUser = useMemo(
    () => !!userData?.roles?.includes("admin"),
    [userData?.roles],
  );
  const effectiveDailyLoginDropAt = Math.max(
    Number(userData?.lastDailyLoginDropAt || 0),
    Number(dailyLoginDropGrantAt || 0),
  );
  const effectiveDailyLoginDropNoticeAt = Math.max(
    Number(userData?.lastDailyLoginDropNoticeAt || 0),
    Number(dailyLoginDropNoticeAt || 0),
  );
  const isDailySpinDue =
    !!userData?.completedTutorial &&
    hasDailyCooldownElapsed(userData?.lastDailySpin || 0);
  const isDailyRewardFlowActive =
    dailyModalOpen || tokenModalVisible || cardModalVisible || xpModalVisible;

  useEffect(() => {
    if (!userData) {
      navigate("/");
    } else if (userData?.partyId) {
      setScreenLoading(true);
      const timeout = setTimeout(() => {
        navigate("/world");
      }, 500); // small delay, but lets TransitionOverlay take over

      return () => clearTimeout(timeout);
    }

    if (userData && !userData?.partyId) {
      setScreenLoading(false);
    }
    // console.log(userData);
  }, [userData]);

  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  const createTokenPurchaseCart = async (product, { locked = false } = {}) => {
    if (!userData?.id) throw new Error("Sign in before buying tokens.");

    const item = normalizeTokenProductForCart(product);
    const totals = computeTotals([item]);
    const payload = sanitizeForFirestore({
      customerID: userData.id,
      items: [item],
      subtotalUSD: totals.totalUSD,
      discountUSD: totals.discountUSD,
      totalUSD: totals.totalAfterDiscountUSD,
      totalTokens: totals.totalTokens,
      promo: null,
      lastUpdated: Date.now(),
      purchased: false,
      locked,
    });

    const cartRef = await addDoc(collection(db, "carts"), payload);
    return { cartId: cartRef.id, item, totals };
  };

  const fetchEthUsdForTokenPurchase = async () => {
    const res = await fetch(
      "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd"
    );
    const data = await res.json();
    return Number(data?.ethereum?.usd || 0);
  };

  const handleBuyTokenProduct = async (product) => {
    try {
      setTokenPurchaseError(null);

      const key = product?.id || product?.name;
      setTokenPurchaseBuyingKey(key);

      const { cartId, totals } = await createTokenPurchaseCart(product, {
        locked: true,
      });
      setTokenCheckoutCartId(cartId);

      const { data } = await axios.post(
        "https://us-central1-infinft-card-game.cloudfunctions.net/app/create_checkout_from_cart",
        {
          cartId,
          url: window.location.href,
          test: window.location.origin.includes("localhost"),
          expectedTotalUSD: totals.totalAfterDiscountUSD,
          promo: null,
        }
      );

      if (!data?.client_secret) throw new Error("No client secret returned");

      setTokenCheckoutClientSecret(data.client_secret);
      setTokenCheckoutOpen(true);
      setTokenPurchaseModalOpen(false);
    } catch (err) {
      console.error("Dashboard token checkout failed:", err?.response?.data || err);
      const message = getRequestErrorMessage(
        err,
        "Couldn't start token checkout."
      );
      setTokenPurchaseError(message);
      setMessage(message);
      if (setError) setError(true);
      else setInfo(true);
    } finally {
      setTokenPurchaseBuyingKey(null);
    }
  };

  const handleBuyTokenProductWithBattleWallet = async (product) => {
    let cartId = null;
    try {
      setTokenPurchaseError(null);

      const key = product?.id || product?.name;
      setTokenPurchaseBattleWalletBuyingKey(key);

      const cart = await createTokenPurchaseCart(product);
      cartId = cart.cartId;

      const rate = await fetchEthUsdForTokenPurchase();
      if (!rate) throw new Error("Couldn't fetch ETH conversion rate.");

      const needed =
        Number(cart.totals?.totalAfterDiscountUSD || 0) / 100 / rate;
      const balance = Number(userData?.battleWalletBalance || 0);
      if (balance < needed) {
        throw new Error("Not enough ETH in your battle wallet. Please top up.");
      }

      const purchaseBattleWalletCart =
        firebaseFunctions.httpsCallable("completeBattleWalletCartPurchase");
      await purchaseBattleWalletCart({
        cartId,
        test: window.location.origin.includes("localhost"),
      });

      setTokenPurchaseModalOpen(false);
      setMessage("Purchase complete! Your Infinity Tokens were added.");
      setInfo(true);
    } catch (err) {
      console.error(
        "Dashboard token Battle Wallet checkout failed:",
        err?.response?.data || err
      );
      const message = getRequestErrorMessage(
        err,
        "Couldn't complete Battle Wallet purchase."
      );
      setTokenPurchaseError(message);
      setMessage(message);
      if (setError) setError(true);
      else setInfo(true);
      if (cartId) {
        try {
          await updateDoc(doc(db, "carts", cartId), {
            locked: false,
            lastUpdated: Date.now(),
          });
        } catch (_) {}
      }
    } finally {
      setTokenPurchaseBattleWalletBuyingKey(null);
    }
  };

  const closeTokenCheckout = async () => {
    setTokenCheckoutOpen(false);
    setTokenCheckoutClientSecret(null);
    if (!tokenCheckoutCartId) return;

    try {
      await updateDoc(doc(db, "carts", tokenCheckoutCartId), {
        locked: false,
        lastUpdated: Date.now(),
      });
    } catch (err) {
      console.error("Failed to unlock dashboard token cart:", err);
    } finally {
      setTokenCheckoutCartId(null);
    }
  };

  // Listen for unread announcements (non-dm, non-friend_request)
  useEffect(() => {
    if (!userData?.id) return;

    const mailRef = collection(db, "users", userData.id, "mail");
    const q = query(
      mailRef,
      where("unread", "==", true),
      // Explicitly only pull announcement types we care about
      where("type", "in", ["general", "event", "promotional"]),
    );

    const unsub = onSnapshot(q, (snap) => {
      const docs = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .sort((a, b) => {
          const aTime =
            (a.createdAt && a.createdAt.toMillis?.()) || a.createdAt || 0;
          const bTime =
            (b.createdAt && b.createdAt.toMillis?.()) || b.createdAt || 0;
          return bTime - aTime; // newest first
        });

      setUnreadAnnouncements(docs);
    });

    return () => unsub();
  }, [userData?.id]);

  useEffect(() => {
    if (unreadAnnouncements.length === 0) {
      setAnnouncementModalVisible(false);
      return;
    }

    if (screenLoading || gameScreenLoading) {
      setAnnouncementModalVisible(false);
      return;
    }

    const timeout = setTimeout(() => {
      setAnnouncementModalVisible(true);
    }, POST_TRANSITION_MODAL_DELAY_MS);

    return () => clearTimeout(timeout);
  }, [gameScreenLoading, screenLoading, unreadAnnouncements.length]);

  useEffect(() => {
    if (!userData?.id) {
      setUnreadMailCount(0);
      return undefined;
    }

    const unreadMailQuery = query(
      collection(db, "users", userData.id, "mail"),
      where("unread", "==", true),
    );

    const unsub = onSnapshot(
      unreadMailQuery,
      (snap) => {
        setUnreadMailCount(snap.size || 0);
      },
      (error) => {
        console.error("Failed to load unread mail count:", error);
        setUnreadMailCount(0);
      },
    );

    return () => unsub();
  }, [userData?.id]);

  useEffect(() => {
    if (!userData?.id) {
      setPendingFriendsCount(0);
      return undefined;
    }

    const pendingFriendsQuery = query(
      collection(db, "users", userData.id, "friends"),
      where("status", "==", "pending"),
    );

    const unsub = onSnapshot(
      pendingFriendsQuery,
      (snap) => {
        setPendingFriendsCount(snap.size || 0);
      },
      (error) => {
        console.error("Failed to load pending friend count:", error);
        setPendingFriendsCount(0);
      },
    );

    return () => unsub();
  }, [userData?.id]);

  // listen for our Phaser “door-proximity” events
  useEffect(() => {
    const cb = (e) => setCanInteract(e.detail);
    window.addEventListener("interact-proximity", cb);
    return () => window.removeEventListener("interact-proximity", cb);
  }, []);

  useEffect(() => {
    if (!userData?.id) {
      setDailyModalOpen(false);
      return;
    }

    if (!isDailySpinDue) {
      setDailyModalOpen(false);
      return;
    }

    if (screenLoading || gameScreenLoading) {
      return;
    }

    const timeout = setTimeout(() => {
      setDailyModalOpen(true);
    }, POST_TRANSITION_MODAL_DELAY_MS);

    return () => clearTimeout(timeout);
  }, [
    gameScreenLoading,
    isDailySpinDue,
    screenLoading,
    userData?.id,
  ]);

  useEffect(() => {
    if (!userData?.id || !userData?.completedTutorial) return;
    if (screenLoading || gameScreenLoading) return;
    if (isDailySpinDue || isDailyRewardFlowActive) return;
    if (dailyLoginDropGrantingRef.current) return;

    const userRef = doc(db, "users", userData.id);
    const shouldShowExistingNotice =
      effectiveDailyLoginDropAt > 0 &&
      effectiveDailyLoginDropNoticeAt < effectiveDailyLoginDropAt;

    if (shouldShowExistingNotice) {
      dailyLoginDropGrantingRef.current = true;
      (async () => {
        try {
          await updateDoc(userRef, {
            lastDailyLoginDropNoticeAt: effectiveDailyLoginDropAt,
          });
          setDailyLoginDropNoticeAt(effectiveDailyLoginDropAt);
          setTokenModalMode("daily-login-drop");
          setTokenModalReward(
            buildDailyLoginDropReward(effectiveDailyLoginDropAt),
          );
          setTokenModalVisible(true);
        } catch (err) {
          console.error("Failed to mark daily login drop notice:", err);
        } finally {
          dailyLoginDropGrantingRef.current = false;
        }
      })();
      return;
    }

    if (!hasDailyCooldownElapsed(effectiveDailyLoginDropAt)) return;

    dailyLoginDropGrantingRef.current = true;
    (async () => {
      try {
        let grantedAt = 0;
        await runTransaction(db, async (transaction) => {
          const userSnap = await transaction.get(userRef);
          if (!userSnap.exists()) {
            throw new Error("User not found.");
          }

          const userDoc = userSnap.data() || {};
          const lastGrantedAt = Number(userDoc?.lastDailyLoginDropAt || 0);
          if (!hasDailyCooldownElapsed(lastGrantedAt)) {
            grantedAt = lastGrantedAt;
            return;
          }

          grantedAt = Date.now();
          transaction.update(userRef, {
            infinityTokens: increment(DAILY_LOGIN_DROP_AMOUNT),
            lastDailyLoginDropAt: grantedAt,
          });
        });

        if (!grantedAt) return;

        setDailyLoginDropGrantAt(grantedAt);

        if (effectiveDailyLoginDropNoticeAt >= grantedAt) return;

        await updateDoc(userRef, {
          lastDailyLoginDropNoticeAt: grantedAt,
        });
        setDailyLoginDropNoticeAt(grantedAt);
        setTokenModalMode("daily-login-drop");
        setTokenModalReward(buildDailyLoginDropReward(grantedAt));
        setTokenModalVisible(true);
      } catch (err) {
        console.error("Failed to grant daily login drop:", err);
      } finally {
        dailyLoginDropGrantingRef.current = false;
      }
    })();
  }, [
    effectiveDailyLoginDropAt,
    effectiveDailyLoginDropNoticeAt,
    gameScreenLoading,
    isDailyRewardFlowActive,
    isDailySpinDue,
    screenLoading,
    userData?.completedTutorial,
    userData?.id,
  ]);

  useEffect(() => {
    if (!userData?.id) return;
    const needsCardSlap =
      userData?.selectedCardSlap === undefined ||
      userData?.selectedCardSlap === null;
    const needsTradeAnimation =
      userData?.selectedTradeAnimation === undefined ||
      userData?.selectedTradeAnimation === null;

    if (!needsCardSlap && !needsTradeAnimation) return;

    updateDoc(doc(db, "users", userData.id), {
      ...(needsCardSlap ? { selectedCardSlap: 1 } : {}),
      ...(needsTradeAnimation ? { selectedTradeAnimation: 1 } : {}),
    }).catch((err) => {
      console.error("Failed to initialize animation defaults:", err);
    });
  }, [
    userData?.id,
    userData?.selectedCardSlap,
    userData?.selectedTradeAnimation,
  ]);

  useEffect(() => {
    if (!userData?.id) return;

    const setPresenceForVisibility = (isVisible) => {
      updatePlayerPresence(userData, {
        online: isVisible,
        status: isVisible ? "dashboard" : "offline",
        inGameRoom: false,
        roomId: null,
        partyId: null,
      });
    };

    // Initial set
    setPresenceForVisibility(!document.hidden);

    // Update when tab visibility changes
    const onVis = () => setPresenceForVisibility(!document.hidden);
    document.addEventListener("visibilitychange", onVis);

    return () => {
      document.removeEventListener("visibilitychange", onVis);
      // When leaving Dashboard, mark offline
      setPlayerOffline(userData.id);
    };
  }, [userData?.id]);

  useEffect(() => {
    if (!userData?.id) return;

    const unsub = subscribeToFriendsOnlineCount(userData.id, (count) => {
      setFriendsOnlineCount(count || 0);
    });

    return () => unsub?.();
  }, [userData?.id]);

  useEffect(() => {
    if (!leagueVisible || !userData?.nfteam) {
      setLeagueTeamData(null);
      return undefined;
    }

    const unsub = onSnapshot(
      doc(db, "nfteams", userData.nfteam),
      (snap) => {
        if (snap.exists()) {
          setLeagueTeamData({ id: snap.id, ...snap.data() });
        } else {
          setLeagueTeamData(null);
        }
      },
      (err) => {
        console.error("Failed to load league team for badge:", err);
        setLeagueTeamData(null);
      },
    );

    return () => unsub();
  }, [leagueVisible, userData?.nfteam]);

  useEffect(() => {
    if (!leagueVisible || !userData?.nfteam || !userData?.id) {
      setLeagueMemberClaims([]);
      return undefined;
    }

    const memberRef = doc(db, "nfteams", userData.nfteam, "members", userData.id);
    const unsub = onSnapshot(
      memberRef,
      (snap) => {
        const claims = Array.isArray(snap.data()?.weeklyClaims)
          ? snap.data().weeklyClaims
          : [];
        setLeagueMemberClaims(claims);
      },
      (err) => {
        console.error("Failed to load league member claims for badge:", err);
        setLeagueMemberClaims([]);
      },
    );

    return () => unsub();
  }, [leagueVisible, userData?.nfteam, userData?.id]);

  useEffect(() => {
    if (!leagueVisible || !userData?.nfteam) {
      setLeagueMembersCount(0);
      return undefined;
    }

    const challengeType = leagueTeamData?.weeklyChallenges?.type;
    if (challengeType !== "members") {
      setLeagueMembersCount(0);
      return undefined;
    }

    const membersRef = collection(db, "nfteams", userData.nfteam, "members");
    const unsub = onSnapshot(
      membersRef,
      (snap) => {
        setLeagueMembersCount(snap.size || 0);
      },
      (err) => {
        console.error("Failed to load league members count for badge:", err);
        setLeagueMembersCount(0);
      },
    );

    return () => unsub();
  }, [leagueVisible, userData?.nfteam, leagueTeamData?.weeklyChallenges?.type]);

  const leagueWeeklyDelta = useMemo(() => {
    const wc = leagueTeamData?.weeklyChallenges;
    const type = wc?.type;
    if (!type) return 0;

    const startingValue = Number(wc?.startingValue ?? 0);
    let currentValue = 0;

    if (type === "members") {
      currentValue = Number(
        leagueMembersCount ||
          leagueTeamData?.membersCount ||
          leagueTeamData?.memberCount ||
          0,
      );
    } else if (type === "eliminations") {
      currentValue = Number(leagueTeamData?.eliminations || 0);
    } else if (type === "wins") {
      currentValue = Number(leagueTeamData?.wins || 0);
    } else if (type === "cardsPlayed") {
      currentValue = Number(leagueTeamData?.cardsPlayed || 0);
    } else if (type === "xp") {
      currentValue = Number(leagueTeamData?.xp || 0);
    }

    return Math.max(0, currentValue - startingValue);
  }, [leagueTeamData, leagueMembersCount]);

  const claimableLeagueWeeklyRewardsCount = useMemo(() => {
    const tasks = leagueTeamData?.weeklyChallenges?.tasks;
    if (!Array.isArray(tasks) || tasks.length === 0) return 0;

    const claims = new Set(leagueMemberClaims || []);
    return tasks.reduce((count, task) => {
      const rewardId = task?.reward?.uid;
      const pts = Number(task?.amount ?? Infinity);
      const completed = leagueWeeklyDelta >= pts;
      const claimed = rewardId && claims.has(rewardId);
      return completed && !claimed && !!rewardId ? count + 1 : count;
    }, 0);
  }, [leagueTeamData, leagueMemberClaims, leagueWeeklyDelta]);

  useEffect(() => {
    if (!userData?.id) {
      setUpcomingEventsCount(0);
      return undefined;
    }

    const computeUpcomingCount = (events = []) => {
      const nowMs = Date.now();
      return events.filter((event) => isEventVisibleInUpcomingBadge(event, nowMs)).length;
    };

    if (isAdminUser) {
      return onSnapshot(
        collection(db, "events"),
        (snap) => {
          const events = snap.docs.map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }));
          setUpcomingEventsCount(computeUpcomingCount(events));
        },
        (err) => {
          console.error("Failed to load events badge count:", err);
          setUpcomingEventsCount(0);
        },
      );
    }

    const publicQ = query(collection(db, "events"), where("public", "==", true));
    const privateQ = query(
      collection(db, "events"),
      where("participantIds", "array-contains", userData.id),
    );

    let publicList = [];
    let privateList = [];

    const emit = () => {
      const merged = new Map();
      [...publicList, ...privateList].forEach((event) => merged.set(event.id, event));
      setUpcomingEventsCount(computeUpcomingCount([...merged.values()]));
    };

    const unsubPublic = onSnapshot(
      publicQ,
      (snap) => {
        publicList = snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        emit();
      },
      (err) => {
        console.error("Failed to load public events badge count:", err);
        publicList = [];
        emit();
      },
    );

    const unsubPrivate = onSnapshot(
      privateQ,
      (snap) => {
        privateList = snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        emit();
      },
      (err) => {
        console.error("Failed to load private events badge count:", err);
        privateList = [];
        emit();
      },
    );

    return () => {
      unsubPublic();
      unsubPrivate();
    };
  }, [userData?.id, isAdminUser]);

  const userSeasonXP = Math.max(
    0,
    Number(userData?.xp || 0) - Number(userData?.seasonPassStartingXp || 0),
  );

  const handleMarkAllAnnouncementsRead = async () => {
    try {
      if (!userData?.id || unreadAnnouncements.length === 0) return;

      const batch = writeBatch(db);
      unreadAnnouncements.forEach((mail) => {
        const ref = doc(db, "users", userData.id, "mail", mail.id);
        batch.update(ref, { unread: false });
      });

      await batch.commit();
      setUnreadAnnouncements([]);
    } catch (err) {
      console.error("Failed to mark announcements as read:", err);
    }
  };

  // We treat *any* close of the AnnouncementModal as "close all" to avoid
  // the user getting spammed with the same announcements again.
  const handleAnnouncementClose = async () => {
    await handleMarkAllAnnouncementsRead();
    setAnnouncementModalVisible(false);
  };

  const ensureStoryProgressDoc = async () => {
    if (!userData?.id) return null;

    const progressRef = doc(db, "users", userData.id, "story", "progress");
    const snap = await getDoc(progressRef);
    if (snap.exists()) return snap.data();

    const initialProgress = buildInitialStoryProgress(storyMissions);
    await setDoc(
      progressRef,
      {
        ...initialProgress,
        startedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );

    return initialProgress;
  };

  const ensureStoryStateDoc = async () => {
    if (!userData?.id) return null;

    const stateRef = doc(db, "users", userData.id, "story", "data");
    const snap = await getDoc(stateRef);
    if (snap.exists()) {
      const currentState = snap.data() || {};
      const nextState = buildInitialStoryState(currentState);
      const hasAllExpectedFields = [
        "infinityTokens",
        "level",
        "xp",
        "inventoryCount",
        "startedAt",
        "updatedAt",
      ].every((key) => Object.prototype.hasOwnProperty.call(currentState, key));

      if (!hasAllExpectedFields) {
        await setDoc(
          stateRef,
          {
            ...nextState,
            startedAt: currentState?.startedAt ?? serverTimestamp(),
            updatedAt: serverTimestamp(),
          },
          { merge: true },
        );
      }

      return nextState;
    }

    const initialState = buildInitialStoryState();
    await setDoc(
      stateRef,
      {
        ...initialState,
        startedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );

    return initialState;
  };

  const handleStartParty = async ({ isNew = false, mode = "online" } = {}) => {
    const randomNumber = Math.floor(Math.random() * 90000) + 10000;
    const userDocRef = doc(db, "users", userData.id);
    await updateDoc(
      userDocRef,
      isNew
        ? {
            partyId: randomNumber,
            isHost: true,
            completedTutorial: false,
            activeGameMode: mode,
            storyModeSolo: mode === "story",
          }
        : {
            partyId: randomNumber,
            isHost: true,
            activeGameMode: mode,
            storyModeSolo: mode === "story",
          },
    );
  };

  const handleStartStoryMode = async () => {
    await Promise.all([ensureStoryProgressDoc(), ensureStoryStateDoc()]);
    setModalOpen(false);
    await handleStartParty({ mode: "story" });
  };

  function cleanString(input) {
    return input.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  }

  const handleJoyMove = (dx, dy) => {
    window.dispatchEvent(
      new CustomEvent("joystick-move", { detail: { dx, dy } }),
    );
  };
  const handleJoyRelease = () => {
    window.dispatchEvent(new Event("joystick-release"));
  };

  const handleAssignedReward = async (reward) => {
    try {
      let rewardData = {
        type:
          reward.type === "token"
            ? "infinity tokens"
            : reward.type === "xp"
              ? reward.type
              : reward.type === "card"
                ? "infinity card"
                : "character card",
        issuedAt: Date.now(),
        claimed: false,
        reward: null,
        amount: null,
      };

      switch (reward.type) {
        case "token":
          rewardData.reward = { currency: "Infinity Tokens" };
          rewardData.amount = reward.amount;
          console.log("Reward: infinity tokens");
          break;
        case "xp":
          rewardData.reward = { currency: "XP" };
          rewardData.amount = reward.amount;
          console.log("Reward: infinity tokens");
          break;
        case "boost":
          const ownedChars =
            (userData.nftCards && userData.nftCards.length > 0
              ? userData.nftCards
              : await loadUserCharacterCards()) || [];
          if (ownedChars.length === 0) {
            console.warn("No character cards owned.");
            return;
          }
          const char = ownedChars[getRandomInt(0, ownedChars.length - 1)];
          rewardData.reward = char;
          rewardData.amount = reward.amount;
          console.log("Reward: character card", rewardData);
          break;

        case "card":
          const nextInfinityCards =
            infinityCards && infinityCards.length > 0
              ? infinityCards
              : (await fetchCards({
                  includeInfinity: true,
                  includeCharacter: false,
                })).infinityCards || [];
          const issuableInfinityCards = getIssuableInfinityCards(nextInfinityCards);
          if (!issuableInfinityCards || issuableInfinityCards.length === 0) {
            console.warn("No infinity cards available.");
            return;
          }
          const card = [...issuableInfinityCards][
            getRandomInt(0, issuableInfinityCards.length - 1)
          ];
          rewardData.reward = card;
          rewardData.amount = reward.amount;
          console.log("Reward: infinty card", rewardData);
          break;

        default:
          break;
      }

      await updateDoc(doc(db, "users", userData.id), {
        lastDailySpin: Date.now(),
      });

      const newRewardId = uuidv4();
      setRewardId(newRewardId);
      const rewardsRef = doc(db, "users", userData.id, "rewards", newRewardId);
      await setDoc(rewardsRef, rewardData);

      setClaimingReward(rewardData);

      switch (reward.type) {
        case "token":
          setTokenModalMode("claim");
          setTokenModalReward(rewardData);
          setTokenModalVisible(true);
          break;
        case "xp":
          setXpModalVisible(true);
          break;
        case "card":
        case "boost":
          setCardReward(rewardData);
          setCardModalVisible(true);
          break;
        default:
          console.warn("Unknown reward type");
          break;
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const finalizeClaim = async () => {
    try {
      const reward = claimingReward;
      if (!reward) {
        console.warn("Reward not found.");
        return;
      }

      const userId = userData.id;
      const rewardRef = doc(db, "users", userId, "rewards", rewardId);

      // 1. Always mark the reward as claimed
      await updateDoc(rewardRef, {
        claimed: true,
        claimedAt: Date.now(),
      });

      const amount = reward.amount || 1;
      const cardId = reward.reward?.cardId || reward.reward?.id;

      // 2. Conditional updates
      switch (reward.type) {
        case "infinity tokens": {
          const userDocRef = doc(db, "users", userId);
          await updateDoc(userDocRef, {
            infinityTokens: increment(amount),
          });
          break;
        }
        case "xp": {
          const userDocRef = doc(db, "users", userId);
          await updateDoc(userDocRef, {
            xp: increment(amount),
          });

          break;
        }

        case "infinity card": {
          if (!cardId)
            return console.warn("No card ID for infinity card reward.");
          const cardRef = doc(db, "users", userId, "Infinity cards", cardId);
          const snap = await getDoc(cardRef);

          if (snap.exists()) {
            await updateDoc(cardRef, {
              amountOwned: increment(amount),
              new: true,
            });
          } else {
            await setDoc(cardRef, {
              ...reward.reward,
              amountOwned: amount,
              createdAt: Date.now(),
              lastUpdated: Date.now(),
              new: true,
            });
          }
          break;
        }

        case "character card": {
          const cardRef = doc(db, "users", userId, "Character cards", cardId);
          const snap = await getDoc(cardRef);

          if (snap.exists()) {
            await updateDoc(cardRef, {
              amountOwned: increment(amount),
              new: true,
            });
          } else {
            await setDoc(cardRef, {
              ...reward.reward,
              amountOwned: amount,
              createdAt: Date.now(),
              lastUpdated: Date.now(),
              new: true,
            });
          }
          break;
        }
        case "sticker":
        case "avatar":
        case "emote": {
          const cosmeticRef = doc(
            db,
            "users",
            userId,
            `${reward.type}s`,
            cardId,
          );
          const snap = await getDoc(cosmeticRef);

          if (snap.exists()) {
            await updateDoc(cosmeticRef, {
              amountOwned: increment(amount),
              new: true,
            });
          } else {
            await setDoc(cosmeticRef, {
              ...reward.reward,
              amountOwned: amount,
              createdAt: Date.now(),
              lastUpdated: Date.now(),
              new: true,
            });
          }
          break;
        }

        case "card pack":
          // Already handled by PackOpeningModal
          break;

        default:
          console.warn("Unknown reward type:", reward.type);
      }

      if (reward.type === "infinity card" || reward.type === "character card") {
        await Promise.allSettled([
          loadUserCards({ force: true }),
          loadUserCharacterCards({ force: true }),
        ]);
      }

      setClaimingReward(null);
      setRewardId(null);
    } catch (err) {
      console.error("Error finalizing claim:", err);
    }
  };

  const closeTokenRewardModal = async () => {
    setTokenModalVisible(false);

    if (tokenModalMode === "claim") {
      await finalizeClaim();
    }

    setTokenModalReward(null);
    setTokenModalMode("claim");
  };

  const handleAnnouncementCTA = (cta) => {
    if (!cta || !cta.actionKey) return;

    switch (cta.actionKey) {
      case "OPEN_WALLET_MODAL":
      case "OPEN_SOCIAL_MODAL":
        // TODO: implement Wallet modal
        setAccountSettingsVisible(true);
        setActiveSection("integrations");
        break;

      case "OPEN_EVENTS_MODAL":
        setAnnouncementModalVisible(false);
        setMailVisible(false);
        setEventsModalIntent({
          eventId: cta?.eventId || null,
          accessCode: cta?.accessCode || "",
        });
        setEventsModalVisible(true);
        break;

      case "OPEN_TOKENS_MODAL":
        // TODO: open Tokens modal / screen
        console.log("CTA:", cta.actionKey, cta);
        break;

      default:
        console.warn("Unknown announcement CTA:", cta);
    }
  };

  const handleOpenEventFromMail = (eventPayload) => {
    setMailVisible(false);
    setEventsModalIntent({
      eventId: eventPayload?.eventId || null,
      accessCode: eventPayload?.accessCode || "",
    });
    setEventsModalVisible(true);
  };

  if (!userData) {
    return null;
  }

  return (
    <Grid
      container
      xs={12}
      sx={{
        // p: { xs: 0, md: 2 },
        height: "100%",
        width: "100%",
        // backgroundImage: `url(${bg})`,
        // backgroundSize: "cover",
        // backgroundPosition: "center",
        // backgroundRepeat: "no-repeat",
        overflowX: "hidden",
        overflowY:"hidden" ,
        position: "relative",
      }}
    >
      <LayeredBackground
        skySrc={season3BgWeb}
        mobileBg={season3BgMobile}
        // foregroundSrc={cityFg}
        // overlay="linear-gradient(180deg, rgba(0,0,0,.15) 0%, rgba(0,0,0,.35) 100%)"
        showForeground={false}
        showStars={false}
        showClouds={false}
        height="100vh"
      />
      {/* <Season3LogoLayer /> */}
      {/* <DashboardLightningLayer /> */}
      <Toast onFinish={() => { }} timeTilClose={3000} />
      <SettingsDrawer
        open={settingsVisible}
        onClose={() => setSettingsVisible(false)}
      />
      <Container
        // maxWidth="xl"
        maxWidth={false}
        disableGutters
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 0 },
          zIndex: 1,
        }}
      >
        {/* ================= DASHBOARD HUD ================= */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            overflow: "clip",
          }}
        >
          {/* Vignette keeps HUD legible over busy art */}
          <Box
            aria-hidden
            sx={{
              position: "absolute",
              inset: 0,
              pointerEvents: "none",
              zIndex: 0,
              background: `linear-gradient(180deg, rgba(7,3,15,0.7) 0%, rgba(7,3,15,0) 18%, rgba(7,3,15,0) 70%, rgba(7,3,15,0.75) 100%), ${gradients.screenVignette}`,
            }}
          />

          {/* ---------- TOP BAR ---------- */}
          <Box
            component="header"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 30,
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.75, md: 1.25 },
              px: { xs: 1, md: 2.5 },
              pt: { xs: 1, md: 1.75 },
            }}
          >
            <HudIconButton
              icon={<MenuRounded />}
              label="Menu"
              size={isMobile ? 40 : 46}
              dataDriver="dashboard-settings"
              onClick={() =>
                runTutorialTap("dashboard-settings", () => {
                  AudioManager.playSFX("buttonPress");
                  setSettingsVisible(true);
                })
              }
            />
            <PlayerPlate
              compact={isMobile}
              badge={getBadgeByLevel(userData?.level)?.badge}
              level={userData?.level || 1}
              name={userData?.username || "Player"}
              xpPercent={xpPercent}
              dataDriver="dashboard-level"
              onClick={() =>
                runTutorialTap("dashboard-level", () => {
                  AudioManager.playSFX("buttonPress");
                  setLevelModalVisible(true);
                })
              }
            />
            {!isMobile && isStaff && (
              <ButtonBase
                onClick={() => {
                  AudioManager.playSFX("buttonPress");
                  navigate("/admin");
                }}
                sx={{
                  height: 30,
                  px: 1.5,
                  borderRadius: 999,
                  fontSize: "0.68rem",
                  fontWeight: 800,
                  letterSpacing: "0.12em",
                  color: "#ffd0d8",
                  border: "1px solid rgba(255,77,109,0.55)",
                  background: "rgba(255,77,109,0.14)",
                  "&:hover": { background: "rgba(255,77,109,0.26)" },
                }}
              >
                {isManagerOnly ? "MANAGER" : "ADMIN"}
              </ButtonBase>
            )}

            <Box sx={{ flex: 1 }} />

            <HudCurrency
              compact={isMobile}
              icon={require("../@shared/assets/infift_token.png")}
              value={formatNumber(userData?.infinityTokens || 0) || 0}
              label="Infinity tokens — buy more"
              showAdd
              dataDriver="dashboard-tokens"
              onClick={() =>
                runTutorialTap("dashboard-tokens", () => {
                  AudioManager.playSFX("buttonPress");
                  setTokenPurchaseError(null);
                  setTokenPurchaseModalOpen(true);
                })
              }
            />
            <HudIconButton
              icon={require("../@shared/assets/icons/reward_icon.png")}
              label="Rewards & quests"
              size={isMobile ? 40 : 46}
              count={unclaimedRewardsAndQuests > 0 ? unclaimedRewardsAndQuests : 0}
              dataDriver="dashboard-rewards"
              onClick={() =>
                runTutorialTap("dashboard-rewards", () => {
                  AudioManager.playSFX("buttonPress");
                  setQuestsAndRewardsVisible(true);
                })
              }
            />
            <HudIconButton
              icon={require("../@shared/assets/icons/book_deck_icon2.png")}
              label="Battle wallet"
              size={isMobile ? 40 : 46}
              dataDriver="dashboard-wallet"
              onClick={() =>
                runTutorialTap("dashboard-wallet", () => {
                  AudioManager.playSFX("buttonPress");
                  setBattleWalletVisible(true);
                })
              }
            />
            {!isMobile && (
              <HudIconButton
                icon={require("../@shared/assets/icons/trophy_icon.png")}
                label="Leaderboard"
                size={46}
                dataDriver="dashboard-leaders"
                onClick={() =>
                  runTutorialTap("dashboard-leaders", () => {
                    AudioManager.playSFX("buttonPress");
                    setLeaderboardVisible(true);
                  })
                }
              />
            )}
            {!isMobile && (
              <>
                <Box
                  aria-hidden
                  sx={{
                    width: "1px",
                    height: 28,
                    mx: 0.5,
                    background: "rgba(255,255,255,0.16)",
                  }}
                />
                {communityLinks.map((link) => (
                  <HudIconButton
                    key={link.key}
                    icon={link.icon}
                    label={`Open InfiNFT ${link.label}`}
                    size={36}
                    onClick={() =>
                      window.open(link.url, "_blank", "noopener,noreferrer")
                    }
                  />
                ))}
              </>
            )}
          </Box>

          {/* ---------- LEFT DOCK ---------- */}
          <Box
            sx={{
              position: "absolute",
              zIndex: 20,
              left: { xs: 8, md: 20 },
              top: { xs: 64, md: 96 },
              width: { xs: "auto", md: 200 },
            }}
          >
            <HudDock title="Shop and collection" compact={isMobile}>
              {isMobile && (
                <HudDockItem
                  compact
                  icon={require("../@shared/assets/icons/trophy_icon.png")}
                  label="LEADERS"
                  dataDriver="dashboard-leaders"
                  onClick={() =>
                    runTutorialTap("dashboard-leaders", () => {
                      AudioManager.playSFX("buttonPress");
                      setLeaderboardVisible(true);
                    })
                  }
                />
              )}
              <HudDockItem
                compact={isMobile}
                icon={require("../@shared/assets/icons/market_icon.png")}
                label="Shop"
                dataDriver="dashboard-shop"
                onClick={() =>
                  runTutorialTap("dashboard-shop", () => {
                    AudioManager.playSFX("buttonPress");
                    setScreenLoading(true);
                    setTimeout(() => {
                      navigate("/store");
                    }, 500);
                  })
                }
              />
              <HudDockItem
                compact={isMobile}
                icon={require("../@shared/assets/icons/treasure_chest_icon.png")}
                label="Buys"
                count={unclaimedPurchasesCount}
                dataDriver="dashboard-buys"
                onClick={() =>
                  runTutorialTap("dashboard-buys", () => {
                    AudioManager.playSFX("buttonPress");
                    setMyPurchasesVisible(true);
                  })
                }
              />
              <HudDockItem
                compact={isMobile}
                icon={require("../@shared/assets/icons/stickers_icon.png")}
                label="Emotes"
                dataDriver="dashboard-emotes"
                onClick={() =>
                  runTutorialTap("dashboard-emotes", () => {
                    AudioManager.playSFX("buttonPress");
                    setEmotesVisible(!emotesVisible);
                  })
                }
              />
              <HudDockItem
                compact={isMobile}
                icon={require("../@shared/assets/icons/screen_icon.png")}
                label={isMobile ? "S3 PASS" : "Season 3"}
                dataDriver="dashboard-season"
                onClick={() => {
                  setInfo(true);
                  setMessage("Season 3 Pass is coming soon! Stay tuned for updates.");
                }}
              />
              {isMobile && (
                <HudDockItem
                  compact
                  icon={require("../@shared/assets/icons/discord.webp")}
                  label="SOCIAL"
                  onClick={(event) => setCommunityAnchorEl(event.currentTarget)}
                />
              )}
            </HudDock>
          </Box>

          {/* ---------- RIGHT DOCK ---------- */}
          <Box
            sx={{
              position: "absolute",
              zIndex: 20,
              right: { xs: 8, md: 20 },
              top: { xs: 64, md: 96 },
              width: { xs: "auto", md: 200 },
            }}
          >
            <HudDock title="Social and competition" side="right" compact={isMobile}>
              <HudDockItem
                side="right"
                compact={isMobile}
                icon={require("../@shared/assets/icons/flag_icon.png")}
                label="Events"
                count={upcomingEventsCount > 0 ? upcomingEventsCount : 0}
                onClick={() => {
                  AudioManager.playSFX("buttonPress");
                  setEventsModalIntent(null);
                  setEventsModalVisible(true);
                }}
              />
              <HudDockItem
                side="right"
                compact={isMobile}
                icon={require("../@shared/assets/icons/clans_icon.png")}
                label="League"
                count={
                  claimableLeagueWeeklyRewardsCount > 0
                    ? claimableLeagueWeeklyRewardsCount
                    : 0
                }
                locked={!userData?.nfteam || userData?.nfteam === ""}
                dataDriver="dashboard-league"
                onClick={() =>
                  runTutorialTap("dashboard-league", () => {
                    AudioManager.playSFX("buttonPress");
                    if (!userData?.nfteam) {
                      setMessage("Join an NFTeam to unlock Leagues");
                      setInfo(true);
                      return;
                    }
                    setLeagueVisible(true);
                  })
                }
              />
              <HudDockItem
                side="right"
                compact={isMobile}
                icon={require("../@shared/assets/icons/nfteams.png")}
                label="NFTeams"
                dataDriver="dashboard-nfteams"
                onClick={() =>
                  runTutorialTap("dashboard-nfteams", () => {
                    AudioManager.playSFX("buttonPress");
                    setNfTeamsVisible(true);
                  })
                }
              />
              <HudDockItem
                side="right"
                compact={isMobile}
                icon={require("../@shared/assets/icons/mail_icon.png")}
                label="Mail"
                count={unreadMailCount || 0}
                dataDriver="dashboard-mail"
                onClick={() =>
                  runTutorialTap("dashboard-mail", () => {
                    AudioManager.playSFX("buttonPress");
                    setMailVisible(true);
                  })
                }
              />
              <HudDockItem
                side="right"
                compact={isMobile}
                icon={require("../@shared/assets/icons/friends_icon.png")}
                label="Friends"
                count={friendsOnlineCount > 0 ? friendsOnlineCount : 0}
                dot={!!pendingFriendsCount}
                dataDriver="dashboard-friends"
                onClick={() =>
                  runTutorialTap("dashboard-friends", () => {
                    AudioManager.playSFX("buttonPress");
                    setFriendsVisible(true);
                  })
                }
              />
              <HudDockItem
                side="right"
                compact={isMobile}
                icon={require("../@shared/assets/icons/referral-icon.png")}
                label={isAmbassador ? "Partner" : isMobile ? "INVITE" : "Referrals"}
                locked={referralsLocked}
                dataDriver="dashboard-referrals"
                onClick={() =>
                  runTutorialTap("dashboard-referrals", () => {
                    if (referralsLocked) {
                      setMessage("Reach Lvl. 25 to unlock Referrals");
                      setInfo(true);
                      return;
                    }
                    AudioManager.playSFX("buttonPress");
                    setReferralOpen(true);
                  })
                }
              />
            </HudDock>
          </Box>

          <Menu
            anchorEl={communityAnchorEl}
            open={Boolean(communityAnchorEl)}
            onClose={() => setCommunityAnchorEl(null)}
          >
            {communityLinks.map((link) => (
              <MenuItem
                key={link.key}
                component="a"
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setCommunityAnchorEl(null)}
                sx={{ gap: 1.25 }}
              >
                {React.isValidElement(link.icon) ? (
                  React.cloneElement(link.icon, { sx: { fontSize: 22 } })
                ) : (
                  <Box
                    component="img"
                    src={link.icon}
                    alt=""
                    sx={{ width: 22, height: 22, objectFit: "contain" }}
                  />
                )}
                {link.label}
              </MenuItem>
            ))}
          </Menu>

          {/* ---------- BOTTOM CTAs ---------- */}
          <Box
            sx={{
              position: "absolute",
              zIndex: 25,
              left: { xs: 10, md: 24 },
              bottom: { xs: 14, md: 24 },
              width: { xs: "40%", sm: 220, md: 240 },
            }}
          >
            <Box
              aria-hidden
              sx={{
                display: { xs: "none", sm: "block" },
                position: "absolute",
                left: "50%",
                bottom: "70%",
                width: { xs: 78, md: 104 },
                height: { xs: 60, md: 80 },
                transform: "translateX(-50%)",
                pointerEvents: "none",
                "& img": {
                  position: "absolute",
                  bottom: 0,
                  width: "46%",
                  borderRadius: "6px",
                  boxShadow: "0 8px 18px rgba(0,0,0,0.5)",
                },
              }}
            >
              <img
                src={require("../@shared/assets/back-of-card.png")}
                alt=""
                style={{ left: "4%", transform: "rotate(-14deg)", transformOrigin: "bottom center" }}
              />
              <img
                src={require("../@shared/assets/back-of-card.png")}
                alt=""
                style={{ left: "50%", transform: "translateX(-50%) rotate(14deg)", transformOrigin: "bottom center", marginLeft: "18%" }}
              />
              <img
                src={require("../@shared/assets/back-of-card.png")}
                alt=""
                style={{ left: "50%", transform: "translateX(-50%) translateY(-8%)" }}
              />
            </Box>
            <HudCta
              variant="cards"
              label="CARDS"
              sublabel="Collection · Decks"
              compact={isMobile}
              icon={<StyleRounded />}
              dataDriver="dashboard-cards"
              onClick={() =>
                runTutorialTap("dashboard-cards", () => {
                  AudioManager.playSFX("buttonPress");
                  setScreenLoading(true);
                  setTimeout(() => {
                    navigate("/mycards");
                  }, 500);
                })
              }
            />
          </Box>

          <Box
            sx={{
              position: "absolute",
              zIndex: 25,
              right: { xs: 10, md: 24 },
              bottom: { xs: 14, md: 24 },
              width: { xs: "40%", sm: 240, md: 280 },
            }}
          >
            <HudCta
              variant="play"
              label="PLAY"
              sublabel="Story · Online · Party"
              compact={isMobile}
              icon={<PlayArrowRounded />}
              dataDriver="dashboard-play"
              onClick={() =>
                runTutorialTap("dashboard-play", () => {
                  AudioManager.playSFX("buttonPress");
                  if (
                    userData?.decks?.length === 0 &&
                    userData?.completedTutorial
                  ) {
                    handleStartParty({ isNew: true, mode: "online" });
                    return;
                  }
                  setModalOpen(true);
                }, {
                  runActionDuringTutorial: true,
                })
              }
            />
          </Box>

          {/* ---------- TUTORIAL DIALOGUE ---------- */}
          {isDashboardDialogueStep ? (
            <Box
              sx={{
                ...glassPanelSx,
                position: "absolute",
                bottom: { xs: "57%", md: "48%" },
                left: "50%",
                transform: "translate(-50%, 0%)",
                width: { xs: "88%", md: "52%" },
                zIndex: 1000,
                p: 2.5,
                pr: 8,
              }}
            >
              <Typography
                sx={{
                  whiteSpace: "pre-line",
                  width: "100%",
                  textAlign: "left",
                  color: "#fff",
                  fontWeight: 500,
                  lineHeight: 1.5,
                }}
              >
                {currentTutorialStep?.text}
              </Typography>
              <Box
                data-driver="next-button"
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: 12,
                  transform: "translateY(-50%)",
                }}
              >
                <HudIconButton
                  icon={<ArrowForwardIos />}
                  label="Next"
                  onClick={advanceTutorialStep}
                />
              </Box>
            </Box>
          ) : null}

          {/* ---------- HERO STAGE ---------- */}
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              top: { xs: "10%", md: "3%" },
              transform: "translateX(-50%)",
              width: { xs: "56%", md: "30%" },
              maxWidth: { xs: "none", md: "560px" },
              aspectRatio: "1411 / 1114",
              zIndex: 1,
              pointerEvents: "none",
              overflow: "visible",
            }}
          >
            {DASHBOARD_LOGO_OVERLAY_LAYERS.map((layer, index) => (
              <motion.img
                key={layer.src}
                src={layer.src}
                alt=""
                aria-hidden
                animate={layer.animate}
                transition={layer.transition}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  opacity: layer.opacity,
                  filter:
                    index === 0
                      ? "drop-shadow(0 0 24px rgba(174, 108, 255, 0.35))"
                      : "drop-shadow(0 0 18px rgba(126, 72, 255, 0.24))",
                  willChange: "transform",
                }}
              />
            ))}
          </Box>

          {/* Platform glow */}
          <Box
            aria-hidden
            sx={{
              position: "absolute",
              left: "50%",
              bottom: { xs: "14%", md: "8%" },
              transform: "translateX(-50%)",
              width: { xs: "70%", md: "34%" },
              height: { xs: "10%", md: "14%" },
              borderRadius: "50%",
              background:
                "radial-gradient(closest-side, rgba(157,133,255,0.55), rgba(124,92,255,0.15) 60%, rgba(124,92,255,0) 100%)",
              filter: "blur(6px)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              bottom: { xs: "15%", md: "9.5%" },
              zIndex: 2,
              left: "50%",
              transform: "translateX(-50%)",
              height: { xs: "40%", md: "56%" },
              aspectRatio: "4/6",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <motion.div
              animate={{ opacity: 1 }}
              transition={{ duration: 0.25 }}
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <AvatarIdolAnimation
                name={userData?.avatar?.name?.toLowerCase()}
                orbImageOffset={userData?.orbAvatar ? "28%" : "0%"}
                style={{}}
                onclick={() => setAvatarSelectorVisible(true)}
              />
            </motion.div>
          </Box>

          {/* Loadout slots flank the avatar */}
          <Box
            sx={{
              position: "absolute",
              zIndex: 3,
              left: "50%",
              bottom: { xs: "max(17%, 104px)", sm: 124, md: "14%" },
              transform: "translateX(-50%)",
              width: { xs: "min(60vw, 240px)", sm: 320, md: "min(34vw, 460px)" },
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              pointerEvents: "none",
              "& > *": { pointerEvents: "auto" },
            }}
          >
            <LoadoutSlot
              compact={isMobile}
              label={userData?.sticker?.name || "Badge"}
              image={
                userData?.sticker?.image ||
                getBadgeByLevel(userData?.level)?.badge
              }
              accent={colors.gold}
              onClick={() => {
                AudioManager.playSFX("buttonPress");
                setStickerSelectorVisible(true);
              }}
            />
            <LoadoutSlot
              compact={isMobile}
              label="Loadout"
              image={require("../@shared/assets/battleboards/deck-closed.png")}
              accent={colors.cyan}
              onClick={() => {
                AudioManager.playSFX("buttonPress");
                setAnimationSelectorVisible(true);
              }}
            />
          </Box>

          {/* THE PODIUM LOCATION */}
          <Box
            sx={{
              position: "absolute",
              bottom: { xs: "-54%", md: "-62%" },
              zIndex: 1,
              left: "50%",
              transform: "translateX(-50%)",
              height: "100%",
              aspectRatio: "5/7",
              display: "flex",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
              }}
            >
              <img
                src={
                  userData?.podium?.image ||
                  require("../@shared/assets/void-city-platform.png")
                }
                alt={userData?.podium?.name || "platform"}
                style={{ width: "100%", height: "auto" }}
              />
            </Box>
          </Box>
        </Box>

        <ModalComponent
          aspectRatio="auto"
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          md={5}
          lg={4}
          ingnorAspect
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 1.1,
              overflowY: "auto",
            }}
          >
            <Box sx={{ textAlign: "center", mb: 0.5 }}>
              <Typography
                sx={{
                  fontSize: "0.66rem",
                  fontWeight: 800,
                  letterSpacing: "0.2em",
                  color: colors.gold,
                }}
              >
                CHOOSE YOUR BATTLE
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Lilita One", sans-serif',
                  fontSize: "2rem",
                  color: "#fff",
                  lineHeight: 1.1,
                }}
              >
                Play
              </Typography>
            </Box>

            <ModeTile
              featured
              title="Story Mode"
              description="Solo campaign. Continue from your last checkpoint."
              icon={<AutoStoriesRounded />}
              accent="#ff8a00"
              onClick={handleStartStoryMode}
            />

            {!userData.test && (
              <ModeTile
                featured
                title="Play Online"
                description="Jump into the shared world and multiplayer."
                icon={<PublicRounded />}
                accent="#00aaff"
                onClick={() => {
                  setModalOpen(false);
                  handleStartParty({ mode: "online" });
                }}
              />
            )}

            <ModeTile
              title="Party Play"
              description="Enter a code or browse active parties."
              icon={<GroupsRounded />}
              accent="#7c5cff"
              onClick={() => setJoinPartyVisible(true)}
            />

            <ModeTile
              title="Match Making"
              description="Enter a code or browse active rooms."
              icon={<BoltRounded />}
              accent="#ff3d9a"
              onClick={() => setJoinRoomVisible(true)}
            />

            <ModeTile
              title="How To Play"
              description="Rules, elements and card types."
              icon={<HelpOutlineRounded />}
              accent="#3ee08f"
              dataDriver="dashboard-how-to-play"
              onClick={() =>
                runTutorialTap(
                  "dashboard-how-to-play",
                  () => {
                    setModalOpen(false);
                    navigate("/how-to-play");
                  },
                  {
                    runActionDuringTutorial: true,
                    onStepMatched: () => setModalOpen(false),
                  },
                )
              }
            />
          </Box>
        </ModalComponent>

        <ModalComponent
          // modalOpen={true}
          modalOpen={dailyModalOpen && userData?.completedTutorial}
          setModalOpen={setDailyModalOpen}
          maxHeight={70}
        >
          <Box
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                mb: 2,
                textAlign: "center",
                padding: "10px",
                borderRadius: "5px",
                backgroundColor: "#00000080",
                width: "100%",
                height: "fit-content",
              }}
            >
              Daily Login Reward
            </Typography>
            {dailyModalOpen && userData?.completedTutorial && (
              <Suspense fallback={null}>
                <SpinWheel
                  mode="daily"
                  onReward={async (reward) => {
                    handleAssignedReward(reward);
                    setDailyModalOpen(false);
                  }}
                />
              </Suspense>
            )}
          </Box>
        </ModalComponent>

        <Suspense fallback={null}>
          {cardReward && cardModalVisible && (
            <CardRewardModal
              visible={cardModalVisible}
              reward={cardReward}
              onClose={() => {
                setCardModalVisible(false);
                finalizeClaim(cardReward.id);
                setCardReward(null);
              }}
            />
          )}
          {tokenModalVisible && (
            <TokenRewardModal
              visible={tokenModalVisible}
              reward={tokenModalReward || claimingReward}
              amount={(tokenModalReward || claimingReward)?.amount}
              onClose={closeTokenRewardModal}
            />
          )}

          {friendsVisible && (
            <FriendsModal
              visible={friendsVisible}
              onClose={() => setFriendsVisible(false)}
            />
          )}
        </Suspense>

        {/* 🔔 Announcements modal for unread general/event/promotional mail */}
        <Suspense fallback={null}>
          {announcementModalVisible && (
            <AnnouncementModal
              visible={announcementModalVisible}
              onClose={() => setAnnouncementModalVisible(false)}
              announcements={unreadAnnouncements}
              onCloseAll={handleAnnouncementClose}
              onCTA={handleAnnouncementCTA}
            />
          )}
        </Suspense>

        <Suspense fallback={null}>
          {mailVisible && (
            <MailModal
              visible={mailVisible}
              onClose={() => setMailVisible(false)}
              userId={userData?.id}
              onOpenEvent={handleOpenEventFromMail}
              onAnnouncementCTA={handleAnnouncementCTA}
            />
          )}
        </Suspense>

        <Suspense fallback={null}>
          {eventsModalVisible && (
            <EventsModal
              visible={eventsModalVisible}
              onClose={() => {
                setEventsModalVisible(false);
                setEventsModalIntent(null);
              }}
              focusEventId={eventsModalIntent?.eventId || null}
              prefillAccessCode={eventsModalIntent?.accessCode || ""}
            />
          )}
        </Suspense>

        <Suspense fallback={null}>
          {stickerSelectorVisible && (
            <StickerSelectorModal
              open={stickerSelectorVisible}
              onClose={() => setStickerSelectorVisible(false)}
            />
          )}
        </Suspense>

        <Suspense fallback={null}>
          {animationSelectorVisible && (
            <AnimationSelectorModal
              open={animationSelectorVisible}
              onClose={() => setAnimationSelectorVisible(false)}
            />
          )}
        </Suspense>

        <EmoteManagerModal
          open={emotesVisible}
          onClose={() => setEmotesVisible(false)}
        />

        <Suspense fallback={null}>
          {avatarSelectorVisible && (
            <AvatarSelectorModal
              open={avatarSelectorVisible}
              onClose={() => setAvatarSelectorVisible(false)}
            />
          )}
        </Suspense>

        <JoinPartyModal
          visible={joinPartyVisible}
          onClose={() => setJoinPartyVisible(false)}
          userId={userData?.id}
        />

        <JoinRoomModal
          visible={joinRoomVisible}
          onClose={() => setJoinRoomVisible(false)}
          userId={userData?.id}
          setStartRoomVisible={setStartRoomVisible}
        />
        <StartRoomModal
          visible={startRoomVisible}
          onClose={() => setStartRoomVisible(false)}
          userId={userData?.id}
        />

        <Suspense fallback={null}>
          {questsAndRewardsVisible && (
            <QuestsAndRewardsModal
              visible={questsAndRewardsVisible}
              onClose={() => setQuestsAndRewardsVisible(false)}
            />
          )}

          {myPurchasesVisible && (
            <MyPurchasesModal
              visible={myPurchasesVisible}
              onClose={() => setMyPurchasesVisible(false)}
            />
          )}

          {myQuestsVisible && (
            <MyQuestsModal
              visible={myQuestsVisible}
              onClose={() => setMyQuestsVisible(false)}
            />
          )}
        </Suspense>

        {/* <TownQuestsModal
					visible={townQuestsVisible}
					onClose={() => setTownQuestsVisible(false)}
					town={"Void City"}
					availableQuests={townQuests}
				  /> */}

        <Suspense fallback={null}>
          {packOpeningVisible && (
            <PackOpeningModal
              visible={packOpeningVisible}
              onClose={() => setPackOpeningVisible(false)}
            />
          )}

          {leaderboardVisible && (
            <LeaderBoardModal
              visible={leaderboardVisible}
              onClose={() => setLeaderboardVisible(false)}
            />
          )}

          {nfTeamsVisible && (
            <NFTeamsModal
              open={nfTeamsVisible}
              onClose={() => setNfTeamsVisible(false)}
            />
          )}

          {leagueVisible && (
            <LeagueModal
              open={leagueVisible}
              onClose={() => setLeagueVisible(false)}
            />
          )}
          {seasonPassVisible && (
            <SeasonPassModal
              open={seasonPassVisible}
              onClose={() => setSeasonPassVisible(false)}
              userLevel={userData?.level || 1}
              userData={userData}
              userSeasonXP={userSeasonXP}
            />
          )}

          {referralOpen && (
            <ReferralModal
              open={referralOpen}
              onClose={() => setReferralOpen(false)}
            />
          )}

          {levelModalVisible && (
            <LevelCheckModal
              visible={levelModalVisible}
              onClose={() => setLevelModalVisible(false)}
            />
          )}
          {battleWalletVisible && (
            <BattleWalletModal
              visible={battleWalletVisible}
              onClose={() => setBattleWalletVisible(false)}
              userData={userData}
              walletBalance={userData?.walletBalance || 0}
              walletAddress={userData?.walletAddress || "0x00...0000"}
            />
          )}
        </Suspense>

        <InfinityTokenPurchaseModal
          visible={tokenPurchaseModalOpen}
          onClose={() => {
            setTokenPurchaseModalOpen(false);
            setTokenPurchaseError(null);
          }}
          tokenBalance={userData?.infinityTokens || 0}
          products={tokenProducts}
          onBuy={handleBuyTokenProduct}
          onBattleWalletBuy={handleBuyTokenProductWithBattleWallet}
          buyingKey={tokenPurchaseBuyingKey}
          battleWalletBuyingKey={tokenPurchaseBattleWalletBuyingKey}
          error={tokenPurchaseError}
        />

        {tokenCheckoutClientSecret && tokenCheckoutOpen && (
          <CheckoutModal
            visible={tokenCheckoutOpen}
            onClose={closeTokenCheckout}
            clientSecret={tokenCheckoutClientSecret}
          />
        )}

        <ServerGateModal
          open={shouldGate}
          currentHost={hostname}
          redirectUrl={PROD_URL}
          allowedRoles={allowedRoles}
          userRoles={userData?.roles || []}
        />
      </Container>
    </Grid>
  );
};

const styles = {
  container: {
    display: "flex",
    flex: 1,
    position: "relative",
    overflow: { xs: "none", md: "hidden" },
  },
  text: { color: "#fff", fontWeight: "bold" },
  sectionBox: {
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    // backgroundColor: "#00000033",
  },
  sectionText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 14,
  },
  userDataCotainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  menuButtonContainer: {
    width: "100%",
    mt: 2,
  },
  menuButton: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      opacity: 0.95,
    },
  },
  menuTitle: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    textShadow: "1px 1px #000",
  },
  menuSubtitle: {
    color: "#fff",
    fontSize: "12px",
    fontWeight: 400,
    textAlign: "center",
    mt: "4px",
  },
};

export default Dashboard;
